import setDecorator from './setDecorator'
import monitoring from './monitoring'
import users from './users'
import workflow from './workflow'

export { setDecorator }

export default {
  monitoring,
  users,
  workflow
}
